import React from "react";
import { Stack, Typography } from "@mui/material";
import dayjs from "dayjs";

import { EMPLOYEE_TYPES, EMPLOYEE_TYPES_DICT } from "../../constants/employees";
import { DEPARTMENTS, FOUNDRIES } from "../../constants";
import {
  CustomRadioGroup,
  HubHookFormDatePicker,
  HubHookFormSelect,
  HubHookFormTagInput,
} from "../../components";
import EmployeeRadioInput from "./EmployeeRadioInput";
import { getUserLocation } from "../../redux";
import { connect } from "react-redux";

const CreateEmployeeHire = ({ defaultLocation = 1 }) => {
  return (
    <Stack gap="15px" width="100%">
      <Typography variant="boldCaptionMain">Hire Details</Typography>
      <Stack gap="15px">
        <CustomRadioGroup
          name="type"
          label="Worker Type"
          options={EMPLOYEE_TYPES}
          defaultValue={EMPLOYEE_TYPES_DICT.FULLTIME}
          CustomComponent={EmployeeRadioInput}
        />
        <Stack direction="row" gap="15px">
          <HubHookFormSelect
            name="locationId"
            label="Location"
            options={FOUNDRIES}
            defaultValue={defaultLocation}
            required
          />
          <HubHookFormDatePicker
            name="doh"
            label="Date of Hire"
            placeholder="MM/DD/YYYY"
            defaultValue={dayjs().toISOString()}
            required
          />
        </Stack>
        <HubHookFormTagInput
          name="departmentIds"
          label="Departments"
          options={DEPARTMENTS}
          required
        />
      </Stack>
    </Stack>
  );
};

const mapStateToProps = (state) => ({
  defaultLocation: getUserLocation(state),
});
export default connect(mapStateToProps)(CreateEmployeeHire);
